export const AD_TYPE_AIMATCH = 'AD_TYPE_AIMATCH'
export const AD_TYPE_HARDCODED = 'AD_TYPE_HARDCODED'
export const AD_UNKNOWN = 'AD_UNKNOWN'

export default {
  AD_TYPE_AIMATCH,
  AD_TYPE_HARDCODED,
  AD_UNKNOWN
}

export const mediaTypes = {
  HTML: 'html',
  JSON: 'json',
  IMAGE: 'image',
  IFRAME: 'frame'
}
